<template>
  <div class="schedule-wrapper">
    <!-- 
        Codigo comentado pela tarefa: https://dvdsunimedfln.atlassian.net/browse/CORE-1990 
        Será ultilizado em um novo periodo, por isso só foi comentado
    -->
    <!-- <div class="card schedule-card">
      <div class="card-body px-4 py-4">
        <div class="schedule-title mb-3">Cronograma de Reembolso 2026</div>

        <table class="table schedule-table mb-0">
          <thead>
            <tr>
              <th>
                <div
                  class="d-flex align-items-center justify-content-center gap-8"
                >
                  <img :src="eventUpcoming" alt=" Para envios até" />
                  <span class="text-center_title">Para envios até</span>
                </div>
              </th>
              <th>
                <div
                  class="d-flex align-items-center justify-content-center gap-8"
                >
                  <img :src="eventAvailable" alt="Paramento em" />
                  <span class="text-center_title">Pagamento em</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in schedule" :key="i">
              <td class="text-center date_timeline">{{ item.deadline }}</td>
              <td class="text-center date_timeline">{{ item.payment }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> -->

    <div class="mt-2 px-1 support-container">
      <img
        :src="whatsapp"
        alt="WhatsApp"
        class="support-container__icon-whatsapp"
      />
      <p class="support-text mb-0">
        Caso necessite de suporte, a equipe de Relacionamento com o Cooperado
        está à disposição para esclarecimentos através do
        <span class="bold-text-700">WhatsApp 48 9154-8297.</span>
      </p>
    </div>

    <div class="d-flex justify-content-end mt-4">
      <button class="btn btn-history" @click="getRequestHistory">
        Histórico de solicitações
      </button>
    </div>
  </div>
</template>

<script>
import eventUpcoming from "../../../assets/images/event_upcoming.svg";
import eventAvailable from "../../../assets/images/event_vailable.svg";
import whatsapp from "../../../assets/images/whatsapp.svg";

export default {
  name: "AnnuityRefundSchedule",
  data() {
    return {
      schedule: [
        { deadline: "15/05", payment: "25/05" },
        { deadline: "15/05 a 25/05", payment: "30/05" },
      ],
      eventUpcoming,
      eventAvailable,
      whatsapp,
      financialCategory: "265",
    };
  },
  methods: {
    getRequestHistory() {
      this.$router.push({
        path: "/historico-solicitacoes",
        query: { category: this.financialCategory },
      });
    },
  },
};
</script>

<style scoped>
* {
  font-family: "Trebuchet MS", sans-serif !important;
}

.bold-text-700 {
  font-weight: 700;
}

.support-container__icon-whatsapp {
  margin-right: 16px;
  flex-shrink: 0;
}

.support-container {
  display: flex;
  align-items: center;
}

.gap-8 {
  gap: 8px;
}

.date_timeline {
  overflow: hidden;
  color: var(--dark-2) !important;
  text-overflow: ellipsis;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  /* 150% */
  letter-spacing: 0.5px;
}

.text-center_title {
  color: var(--green-5);
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
}

.schedule-card {
  border-radius: 12px;
  border: 1px solid var(--background-1);
}

.schedule-title {
  color: var(--dark-2);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 19.2px;
}

.schedule-table {
  border-collapse: collapse;
}

.schedule-table thead th {
  border-top: none;
  border-bottom: 2px solid var(--grey-11);
  color: var(--grey-8);
  font-weight: 600;
  font-size: 0.85rem;
  padding: 10px 16px 14px;
  vertical-align: middle;
}

.table-icon {
  color: var(--green-3);
  font-size: 1rem;
}

.schedule-table tbody td {
  color: var(--grey-12);
  font-size: 16px;
  padding: 16px;
  border-bottom: 1px solid var(--background-4);
}

.schedule-table tbody tr:last-child td {
  border-bottom: none;
}

.whatsapp-icon {
  color: var(--green-3);
  font-size: 1.4rem;
  flex-shrink: 0;
}

.support-text {
  color: var(--green-5);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.btn-history {
  background-color: var(--background-1);
  color: var(--green-5);
  border-radius: 4px;
  padding: 6px 12px;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  transition: background-color 0.2s;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btn-history:hover {
  background-color: var(--grey-10);
}

.d-flex.justify-content-end.mt-4 {
  margin-top: auto !important; 
}
</style>
